import {
  required,
  requiredIf,
  sameAs,
  minLength,
  maxLength,
  email,
  minValue
} from 'vuelidate/lib/validators';

export default {
  order: {
    label_sticky: {
      maxLength: maxLength(40)
    },
    label_sticky_2: {
      maxLength: maxLength(40)
    }
  },
  validationGroup: [
    'order',
  ]
};



// WEBPACK FOOTER //
// ./resources/assets/js/views/Orders/NewShipment/validations.js